var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271.503,
    height: 243.672,
    viewBox: "0 0 271.503 243.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(-0.006 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M348.028,99.595l-8.834,2.278L230.353,129.941l-8.834,2.278a16.727,16.727,0,0,0-12.006,20.351L247.82,301.117a16.727,16.727,0,0,0,20.351,12.006l.023-.006,126.463-32.612.023-.006a16.727,16.727,0,0,0,12.006-20.351L368.379,111.6a16.727,16.727,0,0,0-20.35-12.007Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M358.274,113.3l-10.464,2.7L242.228,143.222l-10.463,2.7a11.911,11.911,0,0,0-8.55,14.492L261.522,308.96a11.911,11.911,0,0,0,14.492,8.55l.023-.006L402.5,284.892l.023-.006a11.911,11.911,0,0,0,8.55-14.492L372.766,121.847A11.911,11.911,0,0,0,358.274,113.3Z",
    transform: "translate(-218.022 -108.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M463.352,242.264l-63.975,16.5a2.782,2.782,0,1,1-1.389-5.388l63.975-16.5a2.782,2.782,0,1,1,1.39,5.388Z",
    transform: "translate(-331.002 -188.968)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M481.219,260.2l-75.088,19.364a2.782,2.782,0,0,1-1.39-5.388l75.088-19.364a2.782,2.782,0,1,1,1.39,5.388Z",
    transform: "translate(-335.411 -200.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M493.62,359.638l-63.975,16.5a2.782,2.782,0,1,1-1.39-5.388l63.975-16.5a2.782,2.782,0,0,1,1.39,5.388Z",
    transform: "translate(-350.761 -265.593)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M511.488,377.574,436.4,396.937a2.782,2.782,0,1,1-1.39-5.388L510.1,372.185a2.782,2.782,0,1,1,1.39,5.388Z",
    transform: "translate(-355.171 -277.302)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M523.889,477.011l-63.975,16.5a2.782,2.782,0,1,1-1.389-5.388l63.975-16.5a2.782,2.782,0,0,1,1.39,5.388Z",
    transform: "translate(-370.522 -342.217)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M541.756,494.947,466.668,514.31a2.782,2.782,0,1,1-1.39-5.388l75.088-19.364a2.782,2.782,0,1,1,1.39,5.388Z",
    transform: "translate(-374.931 -353.926)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M318.979,305.976l-22.64,5.838a1.336,1.336,0,0,1-1.625-.959l-5.2-20.153a1.336,1.336,0,0,1,.959-1.625l22.64-5.838a1.336,1.336,0,0,1,1.625.959l5.2,20.153a1.336,1.336,0,0,1-.959,1.625Z",
    transform: "translate(-261.524 -219.265)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M349.247,423.349l-22.64,5.838a1.336,1.336,0,0,1-1.625-.959l-5.2-20.153a1.336,1.336,0,0,1,.959-1.625l22.64-5.838a1.336,1.336,0,0,1,1.625.959l5.2,20.153A1.336,1.336,0,0,1,349.247,423.349Z",
    transform: "translate(-281.284 -295.89)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M379.515,540.723l-22.64,5.838a1.335,1.335,0,0,1-1.625-.959l-5.2-20.153a1.336,1.336,0,0,1,.959-1.625l22.64-5.838a1.336,1.336,0,0,1,1.625.959l5.2,20.153A1.336,1.336,0,0,1,379.515,540.723Z",
    transform: "translate(-301.044 -372.515)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M586.548,209.052H455.9a16.727,16.727,0,0,0-16.708,16.708V379.167A16.727,16.727,0,0,0,455.9,395.875H586.548a16.727,16.727,0,0,0,16.708-16.708V225.76A16.727,16.727,0,0,0,586.548,209.052Z",
    transform: "translate(-359.265 -170.862)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M595.593,222.906H464.945a11.911,11.911,0,0,0-11.9,11.9V388.212a11.911,11.911,0,0,0,11.9,11.9H595.593a11.911,11.911,0,0,0,11.9-11.9V234.8a11.911,11.911,0,0,0-11.9-11.9Z",
    transform: "translate(-368.309 -179.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 30.499,
    cy: 30.499,
    r: 30.499,
    transform: "translate(210.51 182.679)",
    fill: "#203250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M882.849,674.2H872.24V663.593a3.978,3.978,0,1,0-7.956,0V674.2H853.675a3.978,3.978,0,0,0,0,7.956h10.609v10.608a3.978,3.978,0,0,0,7.956,0V682.158h10.608a3.978,3.978,0,1,0,0-7.956Z",
    transform: "translate(-627.253 -465.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M677.535,455.252H611.467a2.782,2.782,0,1,1,0-5.565h66.068a2.782,2.782,0,1,1,0,5.565Z",
    transform: "translate(-469.913 -327.955)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M689.012,482.3H611.467a2.782,2.782,0,1,1,0-5.565h77.545a2.782,2.782,0,0,1,0,5.565Z",
    transform: "translate(-469.913 -345.612)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M677.535,576.465H611.467a2.782,2.782,0,0,1,0-5.565h66.068a2.782,2.782,0,0,1,0,5.565Z",
    transform: "translate(-469.913 -407.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M689.012,603.513H611.467a2.782,2.782,0,0,1,0-5.565h77.545a2.782,2.782,0,0,1,0,5.565Z",
    transform: "translate(-469.913 -424.744)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M527.6,460.89H504.215a1.336,1.336,0,0,1-1.334-1.334V438.743a1.336,1.336,0,0,1,1.334-1.334H527.6a1.336,1.336,0,0,1,1.334,1.334v20.812A1.336,1.336,0,0,1,527.6,460.89Z",
    transform: "translate(-400.842 -319.94)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M527.6,582.1H504.215a1.336,1.336,0,0,1-1.334-1.334V559.956a1.335,1.335,0,0,1,1.334-1.334H527.6a1.336,1.336,0,0,1,1.334,1.334v20.812A1.336,1.336,0,0,1,527.6,582.1Z",
    transform: "translate(-400.842 -399.071)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M710.387,320.317H661.678a2.782,2.782,0,0,1,0-5.565h48.709a2.782,2.782,0,0,1,0,5.565Z",
    transform: "translate(-502.692 -239.866)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M721.864,347.365H661.678a2.782,2.782,0,0,1,0-5.565h60.186a2.782,2.782,0,1,1,0,5.565Z",
    transform: "translate(-502.692 -257.524)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M548.91,319.689H504a1.336,1.336,0,0,1-1.334-1.334V283.308A1.335,1.335,0,0,1,504,281.974H548.91a1.336,1.336,0,0,1,1.334,1.334v35.046a1.336,1.336,0,0,1-1.334,1.334Z",
    transform: "translate(-400.704 -218.467)",
    fill: "#ccc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmpty);
export default __webpack_public_path__ + "static/media/new-empty.a4db472b.svg";
export { ForwardRef as ReactComponent };